import { api } from '@/utils/apiClient'
import { clearOperatorLocalData } from '@/utils/sessionTeardown'

const LOGOUT_ENDPOINT = '/api/admin/refresh/logout'

interface EndOperatorSessionOptions {
  headers?: Record<string, string>
}

// The single explicit operator-logout seam. Server revocation is best-effort,
// but browser data teardown is unconditional so a failed request cannot leave
// customer or operator data behind on a shared machine.
export async function endOperatorSession(options?: EndOperatorSessionOptions): Promise<void> {
  try {
    if (options) {
      await api.post(LOGOUT_ENDPOINT, undefined, options)
    } else {
      await api.post(LOGOUT_ENDPOINT)
    }
  } catch {
    // The caller still leaves the authenticated surface when the API is down.
  } finally {
    clearOperatorLocalData()
  }
}
